<template>
  <div>
    <div class="bar_nav">
      <div class="title">修改昵称</div>
      <div class="bar_back_btn" @click="goToUserSetting">我</div>
    </div>
    <div class="bar_empty"></div>

    <div class="form">
      <input class="field" label="" placeholder="请输入新昵称" type="text" v-model="user.fullName" />
      <div class="btn_large" @click="save">保存</div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
export default {
  name: 'EditPassword',
  data: function () {
    return {
      user: ''
    }
  },
  async created() {
    try {
      this.user = await this.$faApi.getUserInfo(this.$route.params.userId)
    } catch (err) {
      this.$faLogger.error('EditFullName.vue:created', err)
    }
  },
  methods: {
    async save() {
      try {
        if (!this.user.fullName) {
          return Toast({
            message: '昵称不能为空'
          })
        }
        await this.$faApi.updateUserInfo(this.$route.params.userId, {
          fullName: this.user.fullName
        })
        this.$router.push({ path: `/user/${this.$route.params.userId}/user_setting` })
      } catch (err) {
        this.$faLogger.error('EditUserFullName.vue:save', err)
      }
    },
    goToUserSetting() {
      this.$router.push({ path: `/user/${this.$route.params.userId}/user_setting` })
    }
  }
}
</script>

<style scoped lang="scss">

</style>
    